import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CarritoBackview } from './carrito.component.backview';
import { NgxSpinnerModule } from "ngx-spinner";
import { FormsModule } from '@angular/forms';
import { HeaderModule } from '../header/header.module';
import { FooterModule } from '../footer/footer.module';
import {MatTabsModule} from '@angular/material/tabs';

@NgModule({
  declarations: [CarritoBackview],
  imports: [
    CommonModule,
    HeaderModule,
    FooterModule,
    NgxSpinnerModule,
    FormsModule,
    MatTabsModule,
  ],
  exports: [
    CarritoBackview
  ]
})
export class CarritoModule { }
